<div class="table-filter">
    <mat-form-field id="input">
        <mat-label>{{ "EXPERT.INPUT" | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="{{'EXPERT.PLACEHOLDER' | translate}}" #input />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
</div>

<table mat-table [dataSource]="dataSet" matSort class="mat-elevation-z8">
    <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? this.masterToggle($event) : null" [checked]="selection.hasValue() && isAllSelected() || isFilteredSelected()">
            </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let did">
            <mat-checkbox (change)="this.didChecked(did.did, $event)" [checked]="selection.isSelected(did) || checkedList[did.did]"></mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="ecu_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "EXPERT.TABLE.ECU" | translate}}</th>

        <td mat-cell *matCellDef="let did">{{ did.ecu_id }}</td>
    </ng-container>

    <ng-container matColumnDef="did">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.DID" | translate}}</th>

        <td mat-cell *matCellDef="let did">{{ did.did }}</td>
    </ng-container>

    <ng-container matColumnDef="did_name">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.NAME" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.did_name }}</td>
    </ng-container>

    <ng-container matColumnDef="readWrite">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "EXPERT.TABLE.RW" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.readWrite }}</td>
    </ng-container>

    <ng-container matColumnDef="readLevel">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.R_LV" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.readLevel }}</td>
    </ng-container>

    <ng-container matColumnDef="writeLevel">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.W_LV" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.writeLevel }}</td>
    </ng-container>

    <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.UNIT" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.unit }}</td>
    </ng-container>

    <ng-container matColumnDef="dataType">
        <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.DATATYPE" | translate}}</th>
        <td mat-cell *matCellDef="let did">{{ did.dataType }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
